class AnyServiceModel {
    public siteId: string;
    public isSelected: boolean;
    public anyExceptEmergencies: boolean;
}

export { AnyServiceModel };
